import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import { UncontrolledTooltip } from "reactstrap";
import queryString from "query-string";
const { formatarReal } = require("../../utils");

class Pedido extends Component {
  constructor() {
    super();
    this.toggleAba = this.toggleAba.bind(this);
    this.load = this.load.bind(this);
    this.loadPedidos = this.loadPedidos.bind(this);
    this.loadTotalizadores = this.loadTotalizadores.bind(this);
    this.onChangePeriodo = this.onChangePeriodo.bind(this);
    this.carregaOptionsFiltro = this.carregaOptionsFiltro.bind(this);
    this.mesDescricao = this.mesDescricao.bind(this);
    this.setarFiltro = this.setarFiltro.bind(this);
    this.verificaAutenticacao = this.verificaAutenticacao.bind(this);
    this.onPeriodInicial = this.onPeriodInicial.bind(this);
    this.onPeriodFim = this.onPeriodFim.bind(this);
    this.dataPK = this.dataPK.bind(this);
    this.gerarImpressao = this.gerarImpressao.bind(this);
    this.formatarAgendamentoImpressao = this.formatarAgendamentoImpressao.bind(this);
    this.abrirComprovantePedido = this.abrirComprovantePedido.bind(this);

    this.state = {
      pedidos: [],
      valorTotal: 0,
      totalPedidos: 0,
      periodo: 0,
      paginacao: {
        pagina: 1,
        limite: 10,
      },
      optionsfiltro: [],
      dataInicialFiltro: moment().startOf("month").utc().format(),
      dataFinalFiltro: moment().endOf("month").utc().format(),
      periodoFinal: moment().endOf("month").toDate(), //moment(Date()).format('DD/MM/YYYY'),
      periodoInicial: moment().startOf("month").toDate(), //moment(Date()).format('DD/MM/YYYY'),
      agendas: [],
      dtinicial: false,
      dtFinal: false,
    };
  }

  carregaOptionsFiltro() {
    let options = [];
    for (let i = 0; i <= 5; i++) {
      let dataInicial = moment().subtract(i, "months").startOf("month");
      let dataFinal = moment().subtract(i, "months").endOf("month");
      let mesDescricao = this.mesDescricao(dataInicial.format("MM"));

      if (i === 0) {
        mesDescricao = "Mês atual";
      } else if (i === 1) {
        mesDescricao = "Mês anterior";
      }

      options.push({
        dataInicial: dataInicial.utc().format(),
        dataFinal: dataFinal.utc().format(),
        mesDescricao,
        id: i,
      });
    }

    this.setState({ optionsfiltro: options }, () => {
      this.setarFiltro();
    });
  }

  mesDescricao(mes) {
    let descricao = "";

    switch (mes) {
      case "01":
        descricao = "Janeiro";
        break;

      case "02":
        descricao = "Fevereiro";
        break;

      case "03":
        descricao = "Março";
        break;

      case "04":
        descricao = "Abril";
        break;

      case "05":
        descricao = "Maio";
        break;

      case "06":
        descricao = "Junho";
        break;

      case "07":
        descricao = "Julho";
        break;

      case "08":
        descricao = "Agosto";
        break;

      case "09":
        descricao = "Setembro";
        break;

      case "10":
        descricao = "Outubro";
        break;

      case "11":
        descricao = "Novembro";
        break;

      case "12":
        descricao = "Dezembro";
        break;

      default:
        break;
    }

    return descricao;
  }

  async componentDidMount() {
    this.carregaOptionsFiltro();
  }

  async load() {
    await this.loadPedidos();
    await this.loadTotalizadores();
    this.verificaAutenticacao()
  }

  async loadPedidos() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/consulta-pedidos?datainicial=${
          this.state.dataInicialFiltro
        }&datafinal=${this.state.dataFinalFiltro}&pagina=${
          this.state.paginacao.pagina
        }`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState({ pedidos: response.data.pedidos });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  async loadTotalizadores() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/consulta-pedidos/totalizadores-meses?datainicial=${
          this.state.dataInicialFiltro
        }&datafinal=${this.state.dataFinalFiltro}`,
        this.props.parameters()
      )
      .then((response) => {
        const data = response.data;
        this.setState({
          valorTotal: data.valorTotal,
          totalPedidos: data.totalPedidos,
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  toggleAba(abaAlterar) {
    this.setState({ abaAtiva: abaAlterar });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  onChangePeriodo(e) {
    let value = parseFloat(e.target.value);
    let options = this.state.optionsfiltro;
    let optionFind = options.find((item) => item.id === value);

    this.setState(
      {
        periodo: value,
        dataInicialFiltro: optionFind.dataInicial,
        dataFinalFiltro: optionFind.dataFinal,
        paginacao: { pagina: 1, limite: 10 },
      },
      () => {
        this.loadTotalizadores();
        this.loadPedidos();
      }
    );
  }

  paginar(paginaAlterar) {
    this.setState({ paginacao: { pagina: paginaAlterar, limite: 10 } }, () => {
      this.loadPedidos();
    });
  }

  async setarFiltro() {
    let data = queryString.parse(this.props.location.search).data;

    if (data !== undefined) {
      let options = this.state.optionsfiltro;

      for (let item of options) {
        let dataOption = moment(item.dataInicial).format("YYYY-MM-DD");
        if (dataOption === data) {
          this.setState(
            {
              periodo: item.id,
              dataInicialFiltro: item.dataInicial,
              dataFinalFiltro: item.dataFinal,
            },
            async () => {
              await this.load();
            }
          );
        }
      }
    } else {
      await this.load();
    }
  }

  async verificaAutenticacao() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/verifica-autenticacao`,
        {
          idUsuario: localStorage.getItem("idUsuario"),
          hash: localStorage.getItem("hash"),
        },
        this.props.parameters()
      )
      .then((response) => {
        if (!response.data.valido) {
          this.props.logout();
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  onPeriodInicial(e) {
    this.setState({ periodoInicial: e }, async () => {
      await this.dataPK("inicial"); 
      await this.loadTotalizadores();
      await this.loadPedidos()
    });
  }

  onPeriodFim(e) {
    this.setState({ periodoFinal: e }, async () => { 
      await this.dataPK("final"); 
      await this.loadTotalizadores();
      await this.loadPedidos()
    });
  }

  async dataPK(escolha) {
    let inicio = this.state.dtinicial;
    let final = this.state.dtFinal;
    let dataInicialFiltro = this.state.dataInicialFiltro;
    let dataFinalFiltro = this.state.dataFinalFiltro;
    let periodoInicial = this.state.periodoInicial;
    let periodoFinal = this.state.periodoFinal;
    if (escolha == "inicial") {
      dataInicialFiltro = moment(periodoInicial).format('YYYY-MM-DD 00:00:00');
      if (!inicio) inicio = true;
      else inicio = false;
      this.setState({ dtinicial: inicio, dataInicialFiltro: dataInicialFiltro });
    } else {
      if (!final) final = true;
      else final = false;
      dataFinalFiltro = moment(periodoFinal).format('YYYY-MM-DD 00:00:00');
      this.setState({ dtFinal: final, dataFinalFiltro: dataFinalFiltro });
    }
  }
  
  async gerarImpressao(pedido) {
    let parametros = {...pedido};

    await axios
      .post(
        `${this.props.getBaseUrlImpressao()}/impressao-pedido-orcamento`,
        { parametros }
      )
      .then(async (response) => {
        localStorage.setItem("html", response.data.html);
        localStorage.setItem("tituloPagina", `Comprovante do ${pedido.tipoDoc === 'pedido' ? 'Pedido' : 'Orçamento'} ${pedido.codigo}`);
        window.open("/impressao", "_blank");
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          // this.notificar("warning", error.response.data.erro);
        }
      });
  }

  formatarAgendamentoImpressao(novoPedido) {
    let pedido = JSON.parse(JSON.stringify(novoPedido));

    let pedidoFormatado = {
      codigo: "#" + pedido.codigo,
      tipoPedido: pedido.tipoPedido.desc,
      dataEmissao: moment(pedido.data).format("DD/MM/YYYY"),
      cliente: pedido.cliente.cnpjCpf + " - " + pedido.cliente.desc,
      endereco: {
        rua: pedido.enderecoEntrega.endereco,
        numero: pedido.enderecoEntrega.numero,
        bairro: pedido.enderecoEntrega.bairro,
        cidade: pedido.enderecoEntrega.cidade,
        uf: pedido.enderecoEntrega.estado,
        cep: pedido.enderecoEntrega.cep,
      },
      enderecoEntrega: {
        rua: pedido.enderecoEntrega.endereco,
        numero: pedido.enderecoEntrega.numero,
        bairro: pedido.enderecoEntrega.bairro,
        cidade: pedido.enderecoEntrega.cidade,
        uf: pedido.enderecoEntrega.estado,
        cep: pedido.enderecoEntrega.cep,
      },
      contato: pedido.contato.desc,
      celular: pedido.contato.cel,
      email: pedido.contato.email,
      itens: [],
      total: "",
      condicaoPagamento: pedido.condPagto.desc,
      formaPagamento: pedido.formaPagto.desc,
      transportadora: pedido.transportadora.desc,
      previsaoEntrega: moment(pedido.previsaoEntrega).format("DD/MM/YYYY"),
      ordemCompra: pedido.ordemCompra,
      vendedor: {
        desc: pedido.vendedor.desc,
        celular: pedido.vendedor.cel,
        email: pedido.vendedor.email,
      },
      empresa: {
        desc: pedido.empresa.razaoSocial,
        cnpjCpf: pedido.empresa.cnpjCpf,
        ie: pedido.empresa.ie,
      },
      tipoDoc: pedido.type,
      observacao: pedido.observacao
    };

    let valorTotal = 0;

    for (let item of pedido.itens) {
      pedidoFormatado.itens.push({
        codigo: item.produto.cod,
        un: item.produto.unid,
        desc: item.produto.desc,
        qtd: item.quantidade,
        valorUnitario: `R$ ${formatarReal(
          item.produto.preco.precoUnitComImpostosFinal
        )}`,
        desconto: "R$ 0,00",
        totalItem: `R$ ${formatarReal(
          item.produto.preco.precoTotalComImpostosFinal
        )}`,
        obs: item.produto.obsItemNovo === undefined ? '' : item.produto.obsItemNovo
      });
      valorTotal = valorTotal + item.produto.preco.precoTotalComImpostosFinal;
    }

    console.log(pedidoFormatado);
    pedidoFormatado.total = `R$ ${formatarReal(valorTotal)}`;
    return pedidoFormatado;
  }


  abrirComprovantePedido(pedido){
    let pedidoFormatado = this.formatarAgendamentoImpressao(pedido);
    this.gerarImpressao(pedidoFormatado);
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Consulta de Pedidos" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"pedidos"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="Pedidos"
                  description="Acompanhamento dos pedidos emitidos."
                /> */}

                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/calendar.png"
                                  onClick={() => {
                                    this.dataPK("inicial");
                                  }}
                                  alt="logo"
                                  className="mr-3 mx-3 cal-agenda"
                                  style={{ width: "28px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Período Inicial
                                  </small>
                                  <div className="rel-age">
                                    {this.state.dtinicial && (
                                      <DatePicker
                                        selected={this.state.periodoInicial}
                                        onChange={(date) =>
                                          this.onPeriodInicial(date)
                                        }
                                        inline
                                        locale="pt-BR"
                                      />
                                    )}
                                  </div>
                                  <small
                                    style={{ cursor: "pointer" }}
                                    onClick={(date) => {
                                      this.dataPK("inicial");
                                    }}
                                  >
                                    {moment(this.state.periodoInicial).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </small>
                                </div>
                              </div>
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/calendar.png"
                                  onClick={() => {
                                    this.dataPK("final");
                                  }}
                                  alt="logo"
                                  className="mr-3 mx-3 cal-agenda"
                                  style={{ width: "28px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Período Final
                                  </small>
                                  <div className="rel-age">
                                    {this.state.dtFinal && (
                                      <DatePicker
                                        selected={this.state.periodoFinal}
                                        onChange={(date) =>
                                          this.onPeriodFim(date)
                                        }
                                        inline
                                        locale="pt-BR"
                                      />
                                    )}
                                  </div>

                                  <small
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      this.dataPK("final");
                                    }}
                                  >
                                    {moment(this.state.periodoFinal).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </small>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <span className="simbolo-dinheiro">R$</span>

                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Total de pedidos
                                  </small>
                                  <h5 className="mr-2 mb-0">
                                    {formatarReal(this.state.valorTotal)}
                                  </h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/button.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "25px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    N de pedidos
                                  </small>
                                  <h5 className="mr-2 mb-0">
                                    {this.state.totalPedidos}
                                  </h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/trash.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "25px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Cancelados
                                  </small>
                                  <h5 className="mr-2 mb-0">0</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade"
                            id="sales"
                            role="tabpanel"
                            aria-labelledby="sales-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/calendar.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "28px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Período
                                  </small>
                                  <div className="dropdown">
                                    <a
                                      className="btn btn-secondary dropdown-toggle p-0 bg-transparent border-0 text-dark shadow-none font-weight-medium"
                                      href="#"
                                      role="button"
                                      id="dropdownMenuLinkA"
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      <h5 className="mb-0 d-inline-block">
                                        Mês atual
                                      </h5>
                                    </a>
                                    <div
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuLinkA"
                                    >
                                      <a className="dropdown-item" href="#">
                                        Mês anterior
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-currency-usd mr-3 icon-lg text-danger font-000 teste6"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Total de orçamentos
                                  </small>
                                  <h5 className="mr-2 mb-0">30.020,00</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/button.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "25px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    N de orçamentos
                                  </small>
                                  <h5 className="mr-2 mb-0">30</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/trash.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "25px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Cancelados
                                  </small>
                                  <h5 className="mr-2 mb-0">0</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade"
                            id="purchases"
                            role="tabpanel"
                            aria-labelledby="purchases-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-calendar-heart icon-lg mr-3 text-primary"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Start date
                                  </small>
                                  <div className="dropdown">
                                    <a
                                      className="btn btn-secondary dropdown-toggle p-0 bg-transparent border-0 text-dark shadow-none font-weight-medium"
                                      href="#"
                                      role="button"
                                      id="dropdownMenuLinkA"
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      <h5 className="mb-0 d-inline-block">
                                        26 Jul 2018
                                      </h5>
                                    </a>
                                    <div
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuLinkA"
                                    >
                                      <a className="dropdown-item" href="#">
                                        12 Aug 2018
                                      </a>
                                      <a className="dropdown-item" href="#">
                                        22 Sep 2018
                                      </a>
                                      <a className="dropdown-item" href="#">
                                        21 Oct 2018
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-currency-usd mr-3 icon-lg text-danger"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Revenue
                                  </small>
                                  <h5 className="mr-2 mb-0">$577545</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-eye mr-3 icon-lg text-success"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Total views
                                  </small>
                                  <h5 className="mr-2 mb-0">9833550</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-download mr-3 icon-lg text-warning"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Downloads
                                  </small>
                                  <h5 className="mr-2 mb-0">2233783</h5>
                                </div>
                              </div>
                              <div className="d-flex py-3 border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-flag mr-3 icon-lg text-danger"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Flagged
                                  </small>
                                  <h5 className="mr-2 mb-0">3497843</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 stretch-card">
                    {this.state.pedidos.length > 0 && (
                      <div className="card">
                        <div className="card-body">
                          <div className="table-responsive">
                            {this.state.pedidos.length > 0 && (
                              <table
                                id="recent-purchases-listing"
                                className="table"
                              >
                                <thead>
                                  <tr>
                                    <th>Pedido</th>
                                    <th>Cliente</th>
                                    <th>Situação</th>
                                    <th style={{ textAlign: "right" }}>
                                      Valor total
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      Data
                                    </th>
                                    <th style={{ textAlign: "right" }}>
                                      Ações
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.pedidos.map((pedido, key) => (
                                    <tr key={key}>
                                      <td style={{ fontWeight: "bold" }}>
                                        <Link
                                          to={`/pedido-detalhe?id=${pedido._id}`}
                                          style={{ color: "inherit" }}
                                        >
                                          #{pedido.codigo}
                                        </Link>
                                      </td>
                                      <td>
                                        {pedido.cliente.desc}
                                        <br />{" "}
                                        <span className="font-size-13 font-999">
                                          Pagamento em: {pedido.condPagto.desc}{" "}
                                          - {pedido.formaPagto.desc}
                                        </span>
                                      </td>
                                      <td>
                                        <span
                                          className={`tag cinza`}
                                          style={{ color: "#FFF" }}
                                        >
                                          {pedido.situacao.desc}
                                        </span>
                                      </td>
                                      <td style={{ textAlign: "right" }}>
                                        R$ {formatarReal(pedido.valorTotal)}
                                      </td>
                                      <td style={{ textAlign: "right" }}>
                                        {moment(pedido.data).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td className="text-right">
                                        {/* <Link
                                          to={`/pedido-detalhe?id=${pedido._id}`}
                                        > */}
                                        <div onClick={() => this.abrirComprovantePedido(pedido)}>
                                          <i
                                            className="fa fa-search-plus font-000"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            id={`detalhar-pedido-${pedido._id}`}
                                          ></i>
                                          <UncontrolledTooltip
                                            placement="right"
                                            target={`detalhar-pedido-${pedido._id}`}
                                          >
                                            Detalhar pedido
                                          </UncontrolledTooltip>
                                        {/* </Link> */}
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>

                          <div className="paginacao">
                            <Pagination
                              prevPageText={<i className="fa fa-angle-left" />}
                              nextPageText={<i className="fa fa-angle-right" />}
                              firstPageText={
                                <i className="fa fa-angle-double-left" />
                              }
                              lastPageText={
                                <i className="fa fa-angle-double-right" />
                              }
                              activePage={this.state.paginacao.pagina}
                              itemsCountPerPage={this.state.paginacao.limite}
                              totalItemsCount={this.state.totalPedidos}
                              onChange={(pagina) => this.paginar(pagina)}
                              itemClass="page-item"
                              linkClass="page-link"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Pedido;